import PropTypes from 'prop-types';

// material-ui
import { Box, Grid } from '@mui/material';

// project import
import AuthCard from './AuthCard';
import Logo from 'components/Logo';
import AuthFooter from 'components/cards/AuthFooter';

// assets
import AuthBackground from 'assets/images/auth/AuthBackground';
import { isShopifyApp } from 'context/UserAuthContext';
import config from 'config';

// ==============================|| AUTHENTICATION - WRAPPER ||============================== //

const AuthWrapper = ({ insideCard = true, children }) => (
    <Box sx={{ minHeight: '100vh', background: isShopifyApp() ? 'transparent' : 'linear-gradient(34deg, #0c2941, #164e7d)' }}>
        {/* <AuthBackground /> */}
        <Grid
            container
            direction="column"
            justifyContent="flex-end"
            sx={{
                minHeight: '100vh'
            }}
        >
            <Grid item xs={12}>
                <Grid
                    item
                    xs={12}
                    container
                    justifyContent="center"
                    alignItems="center"
                    sx={{ minHeight: { xs: 'calc(100vh - 134px)', md: 'calc(100vh - 112px)' } }}
                >
                    <Grid item>   
                        {!isShopifyApp() && (
                            <Box sx={{justifyContent: 'center', display: 'flex'}}>
                                <Logo url={process.env.REACT_APP_FRONTEND_URL} style={{color: "white"}} />
                            </Box>
                        )}
                        {insideCard ? (
                        <AuthCard>{children}</AuthCard>
                        ) : children}
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} sx={{ m: 3, mt: 1 }}>
                <AuthFooter />
            </Grid>
        </Grid>
    </Box>
);

AuthWrapper.propTypes = {
    children: PropTypes.node
};

export default AuthWrapper;
